import { fetchData } from "App/utils/helpers";
import { useState, useEffect } from "react";

function useFetch(type, url, data = "body") {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setNewData();
  }, [type, url]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async () => {
    const res = await fetchData(type, url, data);
    if (res) {
      setRows(res);
    } else {
      setRows([]);
    }
  };

  return [rows, setRows];
}

export default useFetch;
